import spinner from "../../../assets/images/loading/vestel-loader.gif";

const VestelSpinner = () => {
  return <img src={spinner} alt="spinner" />;
};

export default VestelSpinner;
